<div class="modal-container flex flex-col">
  <div class="p-6 border-b border-gray-200">
    <div class="flex justify-between items-center">
      <h4 class="text-lg font-semibold text-[#111928]">{{heading}}</h4>
      <button
        type="button"
        class="text-gray-400 hover:text-gray-600 cursor-pointer"
        (click)="onClose()">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>
  </div>

  <div class="p-6 overflow-y-auto flex-grow">
    <form
      [formGroup]="usuarioForm"
      (ngSubmit)="onSave()">
      <div class="space-y-4">
        <div>
          <app-input-custom
            label="Usuario"
            formControlName="username"
            [hasError]="username?.errors?.['required'] && submitted || username?.errors?.['maxlength'] && submitted"
          />
          @if (submitted && username?.errors?.['required']) {
            <p class="text-red-600 text-sm font-normal">
              El Usuario es obligatorio.
            </p>
          }
          @if (submitted && username?.errors?.['maxlength']) {
            <p class="text-red-600 text-sm font-normal">
              El Usuario no puede tener más de 60 caracteres.
            </p>
          }

        </div>

        <div>
          <app-input-custom
            label="Nombre"
            formControlName="nombre"
            [hasError]="(nombre?.errors?.['required'] || nombre?.errors?.['maxlength']) && submitted"
          />
          @if (submitted && nombre?.errors?.['required']) {
            <p class="text-red-600 text-sm font-normal">
              El Nombre es obligatorio.
            </p>
          }
          @if (submitted && nombre?.errors?.['maxlength']) {
            <p class="text-red-600 text-sm font-normal">
              El Nombre no puede tener más de 60 caracteres.
            </p>
          }

        </div>

        <div>
          <app-input-custom
            label="Apellido"
            formControlName="apellido"
            [hasError]="(apellido?.errors?.['required'] || apellido?.errors?.['maxlength']) && submitted"
          />
          @if (submitted && apellido?.errors?.['required']) {
            <p class="text-red-600 text-sm font-normal">
              El apellido es obligatorio.
            </p>
          }
          @if (submitted && apellido?.errors?.['maxlength']) {
            <p class="text-red-600 text-sm font-normal">
              El apellido no puede tener más de 60 caracteres.
            </p>
          }

        </div>

        <div>
          <app-input-custom
            label="Email"
            formControlName="email"
            [hasError]="(email?.errors?.['required'] || email?.errors?.['email'] || email?.errors?.['maxlength']) && submitted"
          />
          @if (submitted && email?.errors?.['required']) {
            <p class="text-red-600 text-sm font-normal">
              El email es obligatorio.
            </p>
          }
          @if (submitted && email?.errors?.['email']) {
            <p class="text-red-600 text-sm font-normal">
              Debe ingresar un formato de correo válido.
            </p>
          }
          @if (submitted && email?.errors?.['maxlength']) {
            <p class="text-red-600 text-sm font-normal">
              El email no puede tener más de 80 caracteres.
            </p>
          }

        </div>

        <div>
          <mat-form-field appearance="outline" class="w-full py-2">
            <mat-select
              formControlName="perfil"
              multiple
              (selectionChange)="getPerfil($event)"
              [compareWith]="comparaPerfil"
              placeholder="Perfiles">
              @for (perfilItem of perfiles; track perfilItem.id) {
                <mat-option [value]="perfilItem">{{perfilItem.nombre}}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          @if (submitted && perfilControl.errors?.['required']) {
            <p class="text-red-600 text-sm font-normal mt-1">
              El perfil es obligatorio.
            </p>
          }
        </div>
      </div>

      <!-- Mover el footer de botones DENTRO del form -->
      <div class="border-t border-gray-200 bg-[#f9fafb]">
        <div class="mt-2 flex justify-end gap-3">
          <app-custom-button
            text="Cancelar"
            textColor="#111928"
            backgroundColor="#FFFFFF"
            borderColor="#9ca3af"
            size="md"
            hoverBackgroundColor="#f9fafb"
            hoverTextColor="#111928"
            (click)="onClose()"
          />
          <app-custom-button
            type="submit"
            text="{{edit ? 'Editar' : 'Agregar'}}"
            textColor="#ffffff"
            backgroundColor="#005FFF"
            borderColor="#005FFF"
            size="md"
            hoverBackgroundColor="#0549BD"
            hoverTextColor="#ffffff"
          />
        </div>
      </div>
    </form>
  </div>
</div>
